import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TooltipModule } from 'primeng/tooltip';
import { OverlayPanelModule } from 'primeng/overlaypanel';

// --- Component ---
import { SidebarComponent } from './sidebar.component';
import { MenuModule } from 'primeng/menu';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';

// --- Dialogs ----
import { FavoritesDialogModule } from '../dialogs/favorites-dialog/favorites-dialog.module';
import { CartDialogModule } from '../dialogs/cart-dialog/cart-dialog.module';

@NgModule({
	declarations: [SidebarComponent],
	imports: [
		CommonModule,
		RouterModule,
		TooltipModule,
		MenuModule,
		ButtonModule,
		BadgeModule,
		OverlayPanelModule,
		FavoritesDialogModule,
		CartDialogModule,
	],
	exports: [SidebarComponent],
})
export class SidebarModule {}
